import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
export var UploadController = /*#__PURE__*/function () {
  function UploadController() {
    _classCallCheck(this, UploadController);
  }
  return _createClass(UploadController, [{
    key: "setAbort",
    value: function setAbort(abortFunction) {
      this.abortFunction = abortFunction;
    }
  }, {
    key: "abort",
    value: function abort() {
      if (this.abortFunction) {
        this.abortFunction();
      }
    }
  }]);
}();